import { i as r } from "./caml_exceptions-99f2c2ac.mjs";

function internalToOCamlException(e) {
  if (r(e)) {
    return e;
  } else {
    return {
      RE_EXN_ID: "JsError",
      _1: e
    };
  }
}

export { internalToOCamlException as i };
